import React, { createContext, useState, useEffect } from 'react';
import User from '../js/user.js';
import * as endPoints from '../js/endpoints';
import { image_path } from '../js/utils';

export const UserContext = createContext({
  user: new User(),
  login: async () => {},
  logout: () => {},
  updateAvatar: () => {},
  updateName: () => {},
  updateLastName: () => {},
});

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => new User());

  // Auto-login mediante token almacenado
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    endPoints.getUserData()
      .then(res => {
        if (res) {
          const u = new User(
            res.user.id,
            res.user.name,
            res.user.last_name,
            res.roles[0].name,
            res.roles.flatMap(r => r.permissions || []),
            res.user.email,
            res.user.created_at,
            res.user.avatar ? image_path(res.user.avatar) : null,
            res.user.color,
            token,
            true
          );
          setUser(u);
        } else {
          logout();
        }
      })
      .catch(() => logout());
  }, []);

  const login = async (email, password) => {
    const res = await endPoints.login(email, password);
    if (!res) throw new Error('Login fallido');
    const u = new User(
      res.user.id,
      res.user.name,
      res.user.last_name,
      res.roles[0].name,
      res.roles.flatMap(r => r.permissions || []),
      res.user.email,
      res.user.created_at,
      res.user.avatar ? image_path(res.user.avatar) : null,
      res.user.color,
      localStorage.getItem('token'),
      true
    );
    setUser(u);
    return u;
  };

  const logout = () => {
    endPoints.logout();
    localStorage.removeItem('token');
    setUser(new User());
  };

  const updateAvatar = (avatar) => {
    setUser(prev => new User(
      prev.id,
      prev.name,
      prev.lastName,
      prev.role,
      prev.permissions,
      prev.email,
      prev.createDate,
      avatar,
      prev.color,
      prev.token,
      prev.isLogged
    ));
  };

  const updateName = (name, lastName) => {
    setUser(prev => new User(
      prev.id,
      name,

      prev.lastName,
      prev.role,
      prev.permissions,
      prev.email,
      prev.createDate,
      prev.avatar,
      prev.color,
      prev.token,
      prev.isLogged
    ));
  };

  const updateLastName = (lastName) => {
    setUser(prev => new User(
      prev.id,
      prev.name,

      lastName,
      prev.role,
      prev.permissions,
      prev.email,
      prev.createDate,
      prev.avatar,
      prev.color,
      prev.token,
      prev.isLogged
    ));
  };

  return (
    <UserContext.Provider value={{ user, login, logout, updateAvatar, updateName, updateLastName }}>
      {children}
    </UserContext.Provider>
  );
}
